import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProjectCard = ({ project }) => {
  const navigate = useNavigate();

  const handleViewProject = () => {
    navigate(`/project/${project.project_id}`);
  };

  return (
    <div className="project-card-enhanced" onClick={handleViewProject}>
      <div className="project-card-background">
        <div className="card-glow-effect"></div>
        <div className="card-gradient-bg"></div>
      </div>
      
      <div className="project-card-header">
        <div className="project-icon-section">
          <div className="project-icon-enhanced">
            <div className="icon-background" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #1a237e 0%, #1976d2 100%)', width: 64, height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {/* SVG Icon with updated color, size, and shape */}
              <svg
                width="44"
                height="44"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 21H20C21.1046 21 22 20.1046 22 19V8C22 6.89543 21.1046 6 20 6H11L9.29687 3.4453C9.1114 3.1671 8.79917 3 8.46482 3H4C2.89543 3 2 3.89543 2 5V19C2 20.1046 2.89543 21 4 21Z"
                  stroke="#fff"
                  strokeWidth={2.2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="icon-ripple"></div>
          </div>
        </div>
      </div>
      
      <div className="project-card-body">
        <div className="project-title-section">
          <h3 className="project-name-enhanced">{project.project_name}</h3>
          <div className="project-metadata">
            <div className="metadata-item">
              <i className="fas fa-hashtag"></i>
              <span>{project.project_id}</span>
            </div>
            <div className={`status-indicator-simple ${project.container_status === 'running' ? 'running' : 'stopped'}`}>
              <i className={`fas ${project.container_status === 'running' ? 'fa-play-circle' : 'fa-stop-circle'}`}></i>
              <span>{project.container_status === 'running' ? 'Running' : 'Stopped'}</span>
            </div>
            {project.collaborators && project.collaborators.length > 0 && (
              <div className="metadata-item">
                <i className="fas fa-users"></i>
                <span>{project.collaborators.length} collaborator{project.collaborators.length !== 1 ? 's' : ''}</span>
              </div>
            )}
          </div>
        </div>
        
      </div>
      
      <div className="project-card-footer">
        <button 
          className="view-project-btn-enhanced"
          onClick={(e) => {
            e.stopPropagation();
            handleViewProject();
          }}
        >
          <div className="btn-background"></div>
          <div className="btn-content-enhanced">
            <span className="btn-text-enhanced">View Project</span>
           
          </div>
        </button>
        
        <div className="project-quick-info">
          <div className="quick-info-item">
            <i className="fas fa-clock"></i>
            <span>Updated {new Date(project.updated_at).toLocaleDateString()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;